import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyL, BrandXS } from 'atoms/typography';
import { PositionIcon } from 'components/lineup/PositionIcon';

import { positionsMap } from '../constants';

const Root = styled(Vertical)`
  align-items: center;
  justify-content: center;
  gap: var(--double-unit);
  background-color: var(--c-nd-50);
  padding: var(--double-unit);
  border-radius: var(--unit);
`;

const StyledPositionIcon = styled(PositionIcon)`
  color: var(--c-blue-400);
`;

const PositionsWrapper = styled(Horizontal).attrs({ center: true })`
  flex-wrap: wrap;
`;
export const Subtitle = () => {
  return (
    <Root>
      <BodyL>
        <FormattedMessage
          id="HowToPlay.ScoutAndCollect.subtitle"
          defaultMessage="Sorare competitions require 5 player lineups."
        />
      </BodyL>
      <Vertical center>
        <Horizontal>
          {positionsMap.slice(0, -1).map((_, index) => {
            const position = positionsMap[index];
            return (
              <PositionsWrapper key={position.position}>
                <StyledPositionIcon
                  position={positionsMap[index].position}
                  className={classnames({
                    purple: true,
                  })}
                />
                <BrandXS uppercase>{position.position}</BrandXS>
              </PositionsWrapper>
            );
          })}
        </Horizontal>
        <Horizontal>
          <StyledPositionIcon
            position={positionsMap[positionsMap.length - 1].position}
            className={classnames({
              purple: true,
            })}
          />
          <BrandXS uppercase>
            <FormattedMessage
              id="HowToPlay.CreateATeam.extraPlayer"
              defaultMessage="One 'Extra' player (either a Defender, Midfielder, or Forward)"
            />
          </BrandXS>
        </Horizontal>
      </Vertical>
    </Root>
  );
};
